import {
  Box,
  Button,
  Container,
  Paper,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useState, useEffect } from "react";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Step1 from "./step1";
import Step2 from "./step2";

function AddDoctor() {
  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState({}); // <== Save all form data here

  const steps = ["Personal Info", "Services"];

  const handleNext = (dataFromStep) => {
    setFormData((prev) => ({ ...prev, ...dataFromStep }));
    setActiveStep((prev) => prev + 1);
  };

  const getStepComponent = () => {
    switch (activeStep) {
      case 0:
        return <Step1 onNext={handleNext} />;
      case 1:
        return (
          <Step2
            val={formData}
            onNext={() => setActiveStep((prev) => prev + 1)}
          />
        );

      default:
        return <div>Done</div>;
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Typography variant="h4">{`Step ${activeStep + 1}: ${
          steps[activeStep]
        }`}</Typography>
        <Paper elevation={3} sx={{ p: 3, mt: 2 }}>
          <Stepper activeStep={activeStep}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>

          {getStepComponent()}
        </Paper>
      </Container>
    </DashboardLayout>
  );
}

export default AddDoctor;
